import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onPressEnter]',
  standalone: false,
})
export class OnPressEnterDirective {
  @Input('onPressEnter') onPressEnter: () => void = () => {};
  constructor(private el: ElementRef) {
    if (el.nativeElement.tagName.toLowerCase() !== 'textarea') {
      console.error(
        'onPressEnter directive should only be used on textarea elements'
      );
    }
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.shift.enter', ['$event'])
  onEnter(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.onPressEnter();
    }
  }
}
